<template>
  <v-col cols="12" class="px-md-1">
    <v-expansion-panels flat class="rounded-0">
      <v-expansion-panel class="ev-2 rounded-0">
        <v-expansion-panel-header
          class="py-0 pl-2 pr-4"
          expand-icon="mdi-menu-down"
        >
          <div class="center-right">
            <span class="body2-regular">باربری و بارنامه</span>
          </div>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="pa-0">
          <div class="border-top pt-3 mx-1">
            <div>
              <span class="body2-light pl-1">نام باربری:</span>
              {{ data.barbari_name ? data.barbari_name : "نام مشخص نشده" }}
            </div>
            <div class="center-right my-2">
              <span class="body2-light pl-1">شماره تماس:</span>
              {{ data.username ? data.username : "تلفن مشخص نشده" }}
              <v-btn
                small
                outlined
                color="success"
                class="mr-auto py-4 px-3 border-2"
                :href="`tel:${data.username ? data.username : ''}`"
              >
                <v-icon left dark> mdi-phone</v-icon>
                تماس
              </v-btn>
            </div>

            <div v-if="loadStep >= 5 && load.waybill_photo">
              <span class="body2-light pl-1">تصویر بارنامه:</span>

              <span class="title-small-text">
                ( برای مشاهده روی عکس کلیک کنید )
              </span>
            </div>
            <img
              v-if="loadStep >= 5 && load.waybill_photo"
              alt=""
              :src="load.waybill_photo ? `${load.waybill_photo}` : ''"
              class="waybill-image mt-2 mr-auto"
              @click="imageDialogHandler('open')"
            />
            <div v-else>تصویر بارنامه یافت نشد</div>
          </div>

          <view-image
            v-if="loadStep >= 5"
            :value="imageDialog"
            :url="load.waybill_photo ? load.waybill_photo : ''"
            @dialog-handler="imageDialogHandler"
          ></view-image>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
const ViewImage = () => import("../components/ViewImage.vue");

export default {
  name: "BarbariDetailPanel",
  components: {
    ViewImage,
  },
  props: {
    load: {
      type: Object,
      required: true,
    },
    loadStep: Number,
  },
  data() {
    return {
      imageDialog: false,
    };
  },
  computed: {
    data() {
      return this.load.barbariInfo[0];
    },
    loadDetails() {
      const type = this.load.load_type;
      const packaging = this.load.package_type;
      const tonnage = this.load.tonnage;
      const dimensions = this.load.dimensions;
      const loadValue = Number(this.load.load_value);
      const desc = this.load.description;

      return {
        type: {
          name: "نوع بار",
          value: type,
          icon: "local_shipping",
        },
        packaging: {
          name: "بسته بندی",
          value: packaging,
          icon: "view_in_ar",
        },
        tonnage: {
          name: "تناژ",
          value: tonnage,
          icon: "check_box",
        },
        dimensions: {
          name: "اندازه بار",
          value:
            String(dimensions[0] ? dimensions[0] : "-") +
            " * " +
            String(dimensions[1] ? dimensions[1] : "-") +
            " * " +
            String(dimensions[2] ? dimensions[2] : "-"),
          icon: "check_box",
        },
        loadValue: {
          name: "ارزش محموله",
          value: this.$utils.formatNumber(loadValue) + " تومان",
          icon: "check_box",
        },
        desc: {
          name: "توضیحات",
          value: desc,
          icon: "error_outline",
        },
      };
    },
  },
  methods: {
    imageDialogHandler(op) {
      if (op === "open") this.imageDialog = true;
      else if (op === "close") this.imageDialog = false;
    },
  },
};
</script>

<style scoped>
.v-expansion-panel-header {
  height: 20px !important;
  max-height: 20px !important;
}
.title-small-text {
  color: rgba(0, 0, 0, 0.87);
  font-size: 12px;
}
.load-detail-text {
  font-size: 12px;
  color: #000000;
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.center-right {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.waybill-image {
  width: auto;
  height: 100%;
  max-height: 100px;
  float: left;
  cursor: pointer;
}
.border-2 {
  border-width: 2px;
}
</style>
